import { List } from 'immutable';
import { createActionCreator } from '../../lib/Actions/factory';

const createAction = createActionCreator('LIST_RESOURCES');

export const SET_VIEW_OPTIONS = createAction('SET_VIEW_OPTIONS', ({
  filters,
  sortColumns,
  sortOrders,
  page,
}) => ({
  filters,
  sortColumns,
  sortOrders,
  page,
}));

export const SET_SELECTED = createAction('SET_SELECTED', ({ ids, mode }) => ({
  ids: ids ? new List(ids) : ids,
  mode,
}));
